import type {KeyTextField, LinkField} from '@prismicio/client'
import {PrismicLink} from '@prismicio/react'
import type {Top10AiToolsSliceDefaultPrimaryHeroStatsItem} from 'prismicio-types'
import React from 'react'

interface Props {
  eyebrow: KeyTextField
  title: KeyTextField
  subtitle: KeyTextField
  desc: KeyTextField
  linkText: KeyTextField
  linkUrl: LinkField
  stats: Top10AiToolsSliceDefaultPrimaryHeroStatsItem[]
}

const HeroSection: React.FC<Props> = ({eyebrow, title, subtitle, desc, linkText, linkUrl, stats}) => (
  <section className="t10-hero">
    {eyebrow && <p className="t10-eyebrow">{eyebrow}</p>}
    {title && <h1 className="t10-hero-title">{title}</h1>}
    {subtitle && <p className="t10-hero-subtitle">{subtitle}</p>}
    {desc && <p className="t10-hero-desc">{desc}</p>}
    {linkText && linkUrl && (
      <PrismicLink field={linkUrl} className="t10-hero-link">
        {linkText}
      </PrismicLink>
    )}

    {stats && stats.length > 0 && (
      <div className="t10-stats-grid">
        {stats.map((stat, i) => (
          <div key={i} className="t10-stat-cell">
            <span className="t10-stat-num">{stat.stat_num}</span>
            <div className="t10-stat-label">{stat.stat_label}</div>
          </div>
        ))}
      </div>
    )}
  </section>
)

export default HeroSection
